export const FETCH_LOCATIONS = 'saved-locations/FETCH_LOCATIONS'
export const CREATE_LOCATIONS = 'saved-locations/CREATE_LOCATIONS'
